var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-canuse-modal"},[_c('p',{staticClass:"p1"},[_vm._v("普通用户查询数量受限")]),_c('p',{staticClass:"p2"},[_vm._v("开通动脉橙机构版，可查看完整内容")]),_c('div',{staticClass:"go-vip-btn",on:{"click":_vm.go}},[_vm._v("申请试用")])])
}
var staticRenderFns = []

export { render, staticRenderFns }